import React, { Component } from 'react'
import { connect } from 'react-redux'
import MobileDetect from 'mobile-detect'

import { setWindowSize, setUserAgent } from '../actions'

import Header from './header'
import Footer from './footer'
import Content from './content'
import Overlay from './overlay'

import './app.css'

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
        }

        this.props.setScreenInfo({
            width: window.innerWidth,
            height: window.innerHeight,
        })
    
       console.log("##App## constructor");

        this.props.setUserAgent(new MobileDetect(window.navigator.userAgent))
        this.updateDimensions = this.updateDimensions.bind(this)
    }
    
    updateDimensions() {
        this.setState({
            width: window.innerWidth,
            height: window.innerHeight,
        })
        console.log("##App## updateDimensions ");
    }
    
    componentDidMount() {
        console.log("##App## componentDidMount");
        window.addEventListener("resize", this.updateDimensions)
    }

    componentWillUnmount() {
        console.log("##App## componentWillUnmount");
        window.removeEventListener("resize", this.updateDimensions)
    } 

    renderBase() {
        if (process.env.NODE_ENV === 'development') {
            return <base href='http://localhost:5000' />
        }
    }
    
    render() {
        return (
            <div style={{width: this.state.width, height: this.state.height}}>
                { this.renderBase() }
                {/* <Header /> */}
                <Content />
                {/* <Footer /> */}
                <Overlay params={window.location.search} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setScreenInfo: (size) => dispatch(setWindowSize(size)),
        setUserAgent: (ua) => dispatch(setUserAgent(ua)),
    }
}

export default connect (null, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/containers/app.js